<template>
  <svg
    width="14px"
    height="17px"
    viewBox="0 0 14 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>bag-plus</title>
    <g
      id="Activity-Monitor"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1499.000000, -450.000000)"
        fill="#006F72"
        fill-rule="nonzero"
        id="Activity-Stream"
      >
        <g transform="translate(1467.000000, 0.000000)">
          <g
            id="Group-26"
            transform="translate(20.000000, 439.068182)"
          >
            <g
              id="Icon"
              transform="translate(0.000000, 0.750000)"
            >
              <g
                id="bag-plus"
                transform="translate(12.000000, 11.000000)"
              >
                <path
                  d="M7,0 C5.28182476,0 3.88890099,1.43280084 3.88890099,3.199992 C2.73435859,3.199992 0.875000972,3.199992 0.777778642,3.199992 C0.348211498,3.199992 0,3.55839821 0,4 L0,12.800016 C0,14.5672072 1.39292377,16 3.11111457,16 L10.8888854,16 C12.6069985,16 14,14.5672072 14,12.800016 L14,4 C14,3.55839821 13.6515552,3.199992 13.2222214,3.199992 C13.124999,3.199992 11.2653303,3.199992 10.1111068,3.199992 C10.1111068,1.43280084 8.71810524,0 7,0 Z M6.99999222,1.6 C7.85943762,1.6 8.55554951,2.31599642 8.55554951,3.199992 C7.13688126,3.199992 6.86310318,3.199992 5.44445827,3.199992 C5.44445827,2.31599642 6.14054682,1.6 6.99999222,1.6 Z M1.55555728,4.799992 C1.98317998,4.799992 3.49284833,4.799992 4.66667963,4.799992 C6.42754714,4.799992 7.5724373,4.799992 9.33332815,4.799992 C10.5069961,4.799992 12.0166645,4.799992 12.4444427,4.799992 L12.4444427,12.800016 C12.4444427,13.6840116 11.7483308,14.400008 10.8888854,14.400008 L3.11111457,14.400008 C2.25198028,14.400008 1.55555728,13.6840116 1.55555728,12.800016 L1.55555728,4.799992 Z M6.99999222,7.199964 C6.57065841,7.199964 6.22221358,7.55836221 6.22221358,7.99996 L6.22221358,8.799956 L5.44445827,8.799956 C5.01489113,8.799956 4.66667963,9.15835421 4.66667963,9.599952 C4.66667963,10.0415498 5.01489113,10.399948 5.44445827,10.399948 L6.22221358,10.399948 L6.22221358,11.199944 C6.22221358,11.6415418 6.57065841,11.99994 6.99999222,11.99994 C7.42932603,11.99994 7.77777086,11.6415418 7.77777086,11.199944 L7.77777086,10.399948 L8.55554951,10.399948 C8.98488332,10.399948 9.33332815,10.0415498 9.33332815,9.599952 C9.33332815,9.15835421 8.98488332,8.799956 8.55554951,8.799956 L7.77777086,8.799956 L7.77777086,7.99996 C7.77777086,7.55836221 7.42932603,7.199964 6.99999222,7.199964 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
